import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { IOnTap } from 'app/models/on-tap';
import * as OnTapBasicActions from './actions'

export interface OnTapBasicState extends EntityState<IOnTap> {
  // additional entity state properties
  selectedId: string | null;
  error: string;
}


export function sortByName(a: IOnTap, b: IOnTap): number {
  return a.name.localeCompare(b.name);
}
export function selectId(a: IOnTap): string {
  return a.id ?? '';
}
export const adapter: EntityAdapter<IOnTap> = createEntityAdapter<IOnTap>({
  sortComparer: sortByName,
  selectId: selectId
});

export const initialState: OnTapBasicState = adapter.getInitialState({
  selectedId: null,
  error: ''
});

export const stateName = 'ontapbasic';

export const onTapBasicReducer = createReducer<OnTapBasicState>(
  initialState,
  on(OnTapBasicActions.loadItemsSuccess, (state, { items }) => {
    return adapter.setAll(items, state);
  })
);

// get the selectors
const { selectAll } = adapter.getSelectors();

// Export selectAll for effect caching
export { selectAll };

const selectOnTapBasicState = createFeatureSelector<OnTapBasicState>(stateName);
export const selectAllItems = createSelector(selectOnTapBasicState, selectAll);
